(function () {
  'use strict';
  function discountedPrice(cents, percent) { return cents - Math.floor(cents * percent / 100); }
  function findVariant(variants, options) { return variants.find(v => v.options.every((value, i) => value === options[i])); }
  async function addItem(url, id, fetcher = fetch) {
    const ids = Array.isArray(id) ? id : [id];
    const response = await fetcher(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({items:ids.map(one => ({id:Number(one),quantity:1}))}) });
    let result;
    try { result = await response.json(); } catch (_) { throw new Error('Réponse du panier indisponible. Vérifiez votre panier avant de réessayer.'); }
    if (!response.ok) throw new Error(result.description || 'Ajout au panier impossible. Vérifiez votre panier avant de réessayer.');
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { discountedPrice, findVariant, addItem };
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.ready) return;
    const form = root.querySelector('[data-kit-form]'); if (!form) return;
    const variants = JSON.parse(root.querySelector('[data-kit-variants]').textContent);
    const select = form.querySelector('[name="id"]');
    const options = [...root.querySelectorAll('[data-kit-option]')];
    const button = form.querySelector('[type="submit"]');
    const error = root.querySelector('[data-kit-error]');
    const gift = root.querySelector('[data-kit-gift]');
    const readyLabel = gift ? 'Ajouter mon kit + mon pot offert' : 'Ajouter mon kit au panier';
    let busy = false;
    function refresh() {
      const variant = findVariant(variants, options.map(el => el.value));
      select.value = variant ? String(variant.id) : '';
      button.disabled = busy || !variant || !variant.available;
      button.textContent = busy ? 'Ajout en cours…' : !variant || !variant.available ? 'Cette combinaison est indisponible' : readyLabel;
      if (variant) {
        root.querySelector('[data-kit-price]').textContent = variant.money;
        const promo = root.querySelector('[data-kit-promo-price]'); if (promo) promo.textContent = variant.promo_money;
      }
    }
    options.forEach(el => el.addEventListener('change', refresh));
    root.querySelector('[data-kit-native]').hidden = true;
    root.querySelector('[data-kit-options]').hidden = false;
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (busy || button.disabled) return;
      busy = true; error.textContent = ''; refresh();
      try {
        await addItem(root.dataset.addUrl, gift && gift.value ? [select.value, gift.value] : select.value);
        window.location.assign(form.querySelector('[name="return_to"]').value);
      } catch (err) {
        error.textContent = err instanceof TypeError ? 'Connexion interrompue. Vérifiez votre panier avant de réessayer.' : err.message;
        error.focus(); busy = false; refresh();
      }
    });
    const mobileBuy = root.querySelector('[data-kit-mobile-buy]');
    if (mobileBuy && typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        mobileBuy.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
      });
      observer.observe(form);
      mobileBuy.querySelector('a').addEventListener('click', () => {
        const choice = form.querySelector('[data-kit-option]');
        if (choice) choice.focus({ preventScroll: true });
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      });
    }
    root.dataset.ready = 'true'; refresh();
  }
  function scan(scope) { scope.querySelectorAll('[data-nostea-kit]').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
